import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, of, Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { AuthService } from '../../../../../core/auth';
import { formatDate } from '../../../../../core/util/date.util';
import { ThemeService } from '../../../../../core/auth/_services/theme.service';

@Component({
  selector: 'kt-company-edit',
  templateUrl: './company-edit.component.html',
  styleUrls: [
    './company-edit.component.scss'
  ]
})
export class CompanyEditComponent implements OnInit, OnDestroy, AfterViewInit {
  itemObs = new Subject<any[]>();
  editObs = new Subject<number>();
  addObs = new Subject<number>();
  private itemFormOptions = {
    name: ["", Validators.required],
    comments: ["",],
    partner_email: ["", Validators.email],
    partner_mobile: [""],
    partner_street: [""],
    partner_comments: [""],
    partner_website: [""],
    partner_rut: [""],
    icon_file: [null],
    theme_id: [null]
  };
  itemForm = this.formBuilder.group(this.itemFormOptions);
  stepList: any[] = [
    {
      icon: "flaticon-user-settings", title: "Datos de contacto", subTitle: "Ingrese datos de contacto", form: [
        [
          { name: "name", label: "Nombre", type: "text" },
          { name: "partner_email", label: "Email", type: "text" },
        ],
        [
          { name: "partner_mobile", label: "Celular", type: "text" },
          { name: "partner_street", label: "Dirección", type: "text" },
        ],
        [
          { name: "partner_rut", label: "Rut", type: "text" },
          { name: "partner_website", label: "Sitio web", type: "text" },
        ],
        [
          { name: "comments", label: "Comentarios", type: "text" },
          { label: "Tema", name: "theme_id", type: "list", optionList: [] },
        ],
      ]
    },
    {
      icon: "flaticon-upload", title: "Logo", subTitle: "Suba el logo de la empresa", form: [
        [
          {
            label: "Imagen", name: "icon_file", type: "image", //iconClass: "icofont icofont-paperclip", 
            onFileChange: (event) => this.onFileChange(event, 'icon_file')
          },
        ],
      ]
    },
  ];

  private subscriptions: Subscription[] = [];
  data: any = {};
  partnerList: any[];
  userList: any[];
  uid: number = -1;

  constructor(
    private companyService: CompanyService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private themeService: ThemeService
  ) { }

  ngOnInit() {
    this.uid = this.authService.getUID();

    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.themeService.getAll())
      ).subscribe((themeList => {

        console.log("theme list"); console.dir(themeList);
        this.stepList[0].form[3][1].optionList = themeList.map(theme => {
          return {
            text: theme.name,
            value: theme.id
          }
        });
        this.data.themeList = themeList;
        this.cdr.detectChanges();
      }))
    )
  }
  ngAfterViewInit() {

  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onItemLoaded(item) {
    this.itemForm.controls.theme_id.patchValue(item.theme_id);
    console.log("on item load:");
  }

  onFileChange(event, source) {
    const controlPatch = {};

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      controlPatch[source] = file;
      console.log("control patch: "); console.dir(controlPatch);

      this.data.icon_filename = this.itemForm.controls.icon_file.value.split('\\').pop();

      var reader = new FileReader();
      const componentRef = this;
      reader.onloadend = function (e) {

        componentRef.data.imageSrc = reader.result;

        console.log("data: ");console.dir(componentRef.data);
        componentRef.cdr.detectChanges();

      };

      reader.readAsDataURL(event.target.files[0]);

    } else {
      controlPatch[source] = null;
    }
    try{
      this.itemForm.patchValue(controlPatch);
    }catch(error){
      console.log(error);
    }
    
  }

  getItem(itemId: number) {
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.companyService.getById(itemId))
      ).subscribe(item => {
        this.onItemLoaded(item);
        if (item.icon_file) {
          item.icon_img = btoa(String.fromCharCode.apply(null, new Uint8Array(item.icon_file)));
        }
        this.itemObs.next(item);
      })
    )
  }

  addItem(item_: any) {
    var item = new FormData();
    for (let key of Object.keys(this.itemForm.controls)) {
      let value = this.itemForm.controls[key].value;
      if (value == undefined || value == null) continue;
      console.log(`se añade ${key} con valor: `); console.dir(value);
      if (value instanceof Date) {
        value = formatDate(value);
      }
      item.append(key, value);
      // }      
    }
    // if (this.mode == 'add') {
    item.append('create_date', 'now()');
    item.append('create_uid', `${this.uid}`);
    // } else if (this.mode == 'edit') {
    // item.append('write_date', 'now()');
    // item.append('write_uid', `${this.uid > 0 ? this.uid : 'null'}`);
    // item.create_uid = this.uid > 0 ? this.uid : 'null';
    // item.create_date = "now()";
    // item.is_installation_contact = 'true';
    // item.active = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.companyService.add(item))
      ).subscribe(newId => {
        this.addObs.next(newId);
      })
    )
  }

  editItem(item_: any) {
    var item = new FormData();
    for (let key of Object.keys(this.itemForm.controls)) {
      let value = this.itemForm.controls[key].value;
      if (value == undefined || value == null) continue;
      console.log(`se añade ${key} con valor: `); console.dir(value);
      if (value instanceof Date) {
        value = formatDate(value);
      }
      item.append(key, value);
      // }      
    }
    // if (this.mode == 'add') {
    //     item.append('create_date', 'now()');
    //     item.append('create_uid', `${this.uid}`);
    // } else if (this.mode == 'edit') {
    item.append('write_date', 'now()');
    item.append('write_uid', `${this.uid > 0 ? this.uid : 'null'}`);
    item.append('id', item_.id);
    item.forEach((value, key, parent)=>{
      console.log(`${key} = ${value}`);
    });
    // }
    // item.write_uid = this.uid > 0 ? this.uid : 'null';
    // item.write_date = "now()";
    // item.is_installation_contact = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.companyService.edit(item))
      ).subscribe(status => {
        if (status == "success") this.editObs.next(item_.id);
        else this.editObs.next(-1);
      })
    )
  }
}